import { GetterTree } from "vuex";
import { StateInterface } from "src/store";
import { IdomStateInterface } from "./state";
import {
  IdomMessagingPolicy,
  IdomSettings,
  IdomEntityItem,
  IdomChannelItem,
  IdomPlatform,
  IdomAutosendOption,
  IdomBotItem,
  IdomRole,
} from "../../models";

const getters: GetterTree<IdomStateInterface, StateInterface> = {
  checkUserTagAccess(context) {
    return (x: string) => {
      console.log(context.userTags, x);
      return context.userTags.indexOf(x) > -1;
    };
  },
  getSettings(context): IdomSettings {
    return context.settings;
  },
  getPolicies(context): IdomMessagingPolicy[] {
    return context.policies.filter((x) => true) || [];
  },
  getEntityItems(context): IdomEntityItem[] {
    return context.entities.filter((x) => true) || [];
  },
  getEntityCount(context): number {
    return context.entitiesCount;
  },
  getChannelItems(context): IdomChannelItem[] {
    return context.channels.filter((x) => true) || [];
  },
  getChannelsCount(context): number {
    return context.channelsCount;
  },
  getBotItems(context): IdomBotItem[] {
    return context.bots.filter((x) => true) || [];
  },
  getBotsCount(context): number {
    return context.botsCount;
  },
  getBotListeners(context): number {
    return context.bots.filter((x) => {
      return (
        x.role_guid == "4415015b-9dae-4aea-b463-9c0de271a399" &&
        !x.blocked &&
        x.enabled
      );
    }).length;
  },
  getPlatforms(context): IdomPlatform[] {
    return context.platforms.filter((x) => true) || [];
  },
  getRoles(context): IdomRole[] {
    return context.roles.filter((x) => true) || [];
  },
  getRoleByGuid(context) {
    return (guid: string) => {
      return context.roles.find((x) => x.guid == guid);
    };
  },
  getAutosendOptions(context): IdomAutosendOption[] {
    return context.autosendOptions.filter((x) => true) || [];
  },
};

export default getters;
